import request from "./../utils/request";

export const CALENDAR_API = {
    listEvents: (userIds, startDate, endDate) => {
        return request({
            url: `/calendar/list-events`,
            method: "get",
            params: {
                userIds,
                startDate,
                endDate,
            },
        }).then((res) => res.data);
    },

    createReservationPlan: (payload) => {
        return request({
            url: `/calendar/reservation-plan`,
            method: "post",
            data: {
                payload,
            },
        }).then((res) => res.data);
    },

    deleteReservationPlan: (reservationPlanId) => {
        return request({
            url: `/calendar/reservation-plan/${reservationPlanId}`,
            method: "delete",
        }).then((res) => res.data);
    },

    updateReservationPlan: ({ reservationPlanId, data }) => {
        return request({
            url: `/calendar/reservation-plan/${reservationPlanId}`,
            method: "put",
            data: {
                data,
            },
        }).then((res) => res.data);
    },

    updateFormInputs: ({ reservationPlanId, payload }) => {
        return request({
            url: `/calendar/reservation-plan/form-item/${reservationPlanId}`,
            method: "put",
            params: {
                payload,
            },
        });
    },

    createCalendarEvent: (payload) => {
        return request({
            url: "/calendar",
            method: "post",
            data: {
                payload,
            },
        });
    },

    getReservationPlan: (reservationId) => {
        return request({
            url: `/calendar/reservation/${reservationId}`,
            method: "get",
        }).then((res) => res.data);
    },

    getAllReservationList: () => {
        return request({
            url: `/calendar/reservations`,
            method: "get",
        }).then((res) => res.data);
    },

    getReservationList: (userId) => {
        return request({
            url: `/calendar/reservations/${userId}`,
            method: "get",
        }).then((res) => res.data);
    },

    deleteCalendarEvent: (payload) => {
        return request({
            url: `/calendar/event`,
            method: "delete",
            data: {
                userId: payload.userId,
                eventId: payload.eventId,
                deleteType: payload.deleteType,
            },
        });
    },

    getReservationPlans: () => {
        return request({
            url: `/calendar/reservation-plans`,
            method: "get",
        }).then((res) => res.data);
    },

    getReservationEvents: (reservationId, startDate, endDate, userId) => {
        return request({
            url: `/calendar/reservation-events/${reservationId}`,
            method: "get",
            params: {
                startDate,
                endDate,
                userId,
            },
        }).then((res) => res.data);
    },

    updateReservationEvent: (id, updatingFields) => {
        return request({
            url: `/calendar/reservation-event/${id}/update`,
            method: "post",
            data: {
                updatingFields,
            },
        });
    },
};

export function updateCalendarEvent(eventId, payload) {
    return request({
        url: `/calendar/${eventId}`,
        method: "put",
        data: {
            payload,
        },
    });
}

export function getCalendarEvents(calendarIds, userId, startDate, endDate) {
    return request({
        url: `/calendar/calendar-events/${userId}`,
        method: "get",
        params: {
            calendarIds,
            startDate,
            endDate,
        },
    });
}

export function getSelectUserCalendarEvents() {}

export function getEventDetail(eventId) {
    return request({
        url: `/calendar/detail/${eventId}`,
        method: "get",
    });
}

export function updateCalendarSettings(userId, payload) {
    return request({
        url: `/calendar/settings/${userId}`,
        method: "put",
        data: {
            payload,
        },
    });
}

export function getCalendarSettings(userId) {
    return request({
        url: `/calendar/settings/${userId}`,
        method: "get",
    });
}

export function getTaskEvents(userId) {
    return request({
        url: `/calendar/tasks/${userId}`,
        method: "get",
    });
}

export function markCompletedTask(eventId) {
    return request({
        url: `/calendar/mark-completed-task/${eventId}`,
        method: "put",
    });
}

export function isEnableUserAccount(userId) {
    return request({
        url: `/calendar/is-calendar-feature-enabled/${userId}`,
        method: "get",
    });
}

export function createDefaultCalendar(userId, userName) {
    return request({
        url: `/calendar/create-default-calendar/${userId}`,
        method: "post",
        data: {
            userName,
        },
    });
}

export function getUserCalendars(userId) {
    return request({
        url: `/calendar/user-calendars/${userId}`,
        method: "get",
    });
}

export function createCalendar(userId, payload) {
    return request({
        url: `/calendar/create-calendar/${userId}`,
        method: "post",
        data: {
            payload,
        },
    });
}

export function updateCalendarColor(userId, payload) {
    return request({
        url: `/calendar/update-calendar-color/${userId}`,
        method: "put",
        data: {
            payload,
        },
    });
}

export function getCalendarList(userId, userName) {
    return request({
        url: `/calendar/calendar-list/${userId}`,
        method: "get",
        params: {
            userName,
        },
    });
}

export function calendarDisconnect(userId, authId, isDeleteAll) {
    return request({
        url: `/calendar/calendar-disconnect/${userId}`,
        method: "get",
        params: {
            authId,
            isDeleteAll,
        },
    });
}

export function getTodayEvents(userId) {
    return request({
        url: `/calendar/today-events/${userId}`,
        method: "get",
    });
}

export function updateSetting(userId, setting, value) {
    return request({
        url: `/calendar/settings/${userId}`,
        method: "put",
        data: {
            setting,
            value,
        },
    });
}

export function getVisitorEvents(visitorId, page, pageSize) {
    return request({
        url: `/calendar/visitor-events/${visitorId}`,
        method: "get",
        params: {
            page,
            pageSize,
        },
    });
}

export function changeVisibility(calendarId, visibility) {
    return request({
        url: `/calendar/change-visibility/${calendarId}`,
        method: "put",
        params: {
            visibility,
        },
    });
}

export function getCalendarDetail(calendarId) {
    return request({
        url: `/calendar/visibility/${calendarId}`,
        method: "get",
    });
}

export function deleteCalendar(userId, calendarId, isDeleteEvents) {
    return request({
        url: `/calendar/${calendarId}`,
        method: "delete",
        params: {
            userId,
            isDeleteEvents,
        },
    });
}

export function updateReservationLandingPage(updatingFields) {
    return request({
        url: `/calendar/reservation-landing-page-multi-key`,
        method: "put",
        data: {
            updatingFields,
        },
    });
}

export function createMockReservationLandPage() {
    return request({
        url: `/calendar/reservation-landing-page/create-mock`,
        method: "post",
    });
}
export function getReservationLandingPage() {
    return request({
        url: `/calendar/reservation-landing-page`,
        method: "get",
    });
}
